export const MUST_CONTAIN_FILTER = "CONTAIN";
export const MUST_NOT_CONTAIN_FILTER = "NOT_CONTAIN";
export const MUST_MATCH_ANY_FILTER = "MATCH_ANY";
export const MUST_MATCH_NONE_FILTER = "MATCH_NONE";
export const MUST_MATCH_ALL_FILTER = "MATCH_ALL";
